import * as React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';

import styles from './ContractDetails.module.scss';

export const ContractDetails = translate()(props => {
  const { contract, t } = props;

  return (
    <div className={styles['contract-details']}>
      <b>{t('general:contracts.labels.details')}:</b>
      <ul>
        <li>
          {t('general:contract')}:{' '}
          <Link to={`/orders/${contract.id}`}>{contract.er_contract_number}</Link>
        </li>
        <li>
          {t('general:labels.po_number')}: {contract.er_po_number}
        </li>
        <li>
          {t('general:labels.expected_end_date')}:{' '}
          <Moment date={contract.er_expected_end_date} format="MMMM DD, YYYY" />
        </li>
        {contract.new_contract_end_date && (
          <li>
            {t('general:labels.new_contract_end_date')}:{' '}
            <Moment date={contract.new_contract_end_date} format="MMMM DD, YYYY" />
          </li>
        )}
      </ul>
    </div>
  );
});

ContractDetails.propTypes = {
  contract: PropTypes.object.isRequired,
  t: PropTypes.func,
};
